<template>
    <transition-group name="list" tag="div">
        <slot/>
    </transition-group>
</template>

<script>
export default {
    name: 'TransitionList',
    methods: {
        
    }
};
</script>

<style lang="scss">
    
    .list-enter, .list-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
    .list-leave-active {
        position: absolute;
    }

    //Make sure to add this class to the list items within transition-list
    .transition-list-item {
        transition: all .3s;
    }

</style>